import { Environment } from "./environment.type";

export const environment: Environment = {
	production: true,
	currentHost: '__PROPOOL_RELEASE_HOST__',
	apiHost : '__PROPOOL_RELEASE_API_HOST__',
	idHost: '__PROPOOL_RELEASE_ID_HOST__',
	login_path: 'profile/login',
	client_id: 'propoolapp',
	lockAnonymousFeatures: true,
    darkMode: 'auto',
    version: '__PROPOOL_VERSION__',
	options: {
		pageSize: 10
	}
};
